import { BREAKPOINTS_PX } from '../globalStyle/mediaQueries';


/**
 * Returns whether or not the given window comes from a mobile device
 */
export const isOnMobile = (
  win: Window,
): boolean => win.matchMedia(`only screen and (max-width: ${BREAKPOINTS_PX.MOBILE}px)`).matches;
